module.exports = __webpack_public_path__ + "img/03c5f68.png";